module.exports = __webpack_public_path__ + "img/75736.c1af8068.svg";